<template>
  <div class="zac-replist">
    <div class="d-flex align-center pa-2 grey lighten-3">
      <span class="caption font-weight-bold">REPS ({{ reps.length }})</span>
      <v-tooltip bottom>
        <v-icon slot="activator" small class="ml-1" color="grey">help_outline</v-icon>
        <span>Click a rep's ZIP count to see the full list of their ZIPs.</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn small flat color="primary" class="my-0" @click="$emit('add-new-rep')">+ New Rep</v-btn>
    </div>
    <div v-for="trz in reps" :key="trz.territoryXRepId" class="zac-rep-row">
      <span class="zac-swatch" :style="{ backgroundColor: trz.color }"></span>
      <div class="flex-grow">
        <div class="zac-rep-name d-flex align-center">
          <span>{{ trz.repName }}</span>
          <v-btn x-small flat color="primary" class="ml-1 my-0 zac-highlight-btn"
            title="Flash all of this rep's ZIPs on the map for 3 seconds"
            @click.stop="$emit('highlight', trz.territoryXRepId)">Highlight In Map</v-btn>
        </div>
        <div class="caption grey--text">
          {{ trz.territoryId }} ·
          <a class="zac-zips-link" @click.stop="openPopover(trz, $event)">{{ trz.zips.length }} ZIPs<span v-if="changedCount(trz) > 0"> with {{ changedCount(trz) }} new assigned</span></a>
          · {{ formatSales(trz.terrRepSalesAmt) }} of last 12 mo
        </div>
      </div>
    </div>

    <v-menu v-model="popoverOpen" :position-x="popoverX" :position-y="popoverY"
      :close-on-content-click="false" absolute offset-y>
      <v-card v-if="popoverRep" class="zac-popover" max-width="320">
        <v-card-title class="py-2">
          <span class="subheading"><b>{{ popoverRep.repName }}</b> — {{ popoverRep.zips.length }} ZIPs</span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="popoverOpen = false"><v-icon small>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-1 pb-0">
          <div class="caption red--text">Newly-assigned ZIPs are shown in red.</div>
        </v-card-text>
        <v-card-text class="zac-zips-list pt-2">
          <span v-for="(z, i) in popoverRep.zips" :key="z.zip">
            <span :class="{ 'zac-zip-changed': z.changed }">{{ z.zip }}</span><span v-if="i < popoverRep.zips.length - 1">, </span>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn small flat @click="copy">Copy</v-btn>
          <v-btn small flat color="primary" @click="highlight">Highlight on map</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { formatSales } from './formatSales'
export default {
  props: {
    reps: { type: Array, default: () => [] },
  },
  data: () => ({
    popoverOpen: false,
    popoverX: 0,
    popoverY: 0,
    popoverRep: null,
  }),
  computed: {
    zipsCsv () {
      if (!this.popoverRep) return ''
      return this.popoverRep.zips.map(z => z.zip).join(', ')
    },
  },
  methods: {
    formatSales,
    // Count of ZIPs assigned during this session (the `changed` flag is
    // set by onAssignZips in the parent view).
    changedCount (trz) { return trz.zips.filter(z => z.changed).length },
    openPopover (trz, evt) {
      this.popoverRep = trz
      this.popoverX = evt.clientX
      this.popoverY = evt.clientY
      this.popoverOpen = true
    },
    copy () {
      if (navigator.clipboard) navigator.clipboard.writeText(this.zipsCsv)
    },
    highlight () {
      this.$emit('highlight', this.popoverRep.territoryXRepId)
      this.popoverOpen = false
    },
  },
}
</script>

<style scoped>
.zac-replist            { display: flex; flex-direction: column; }
.zac-rep-row            { display: flex; align-items: center; padding: 6px 8px; border-bottom: 1px solid #eee; gap: 8px; }
.zac-rep-row:hover      { background: #f5f5f5; }
.zac-swatch             { width: 8px; height: 28px; border-radius: 2px; flex: 0 0 8px; }
.flex-grow              { flex: 1; min-width: 0; }
.zac-rep-name           { font-weight: 600; font-size: 13px; }
.zac-zips-link          { color: #1976d2; text-decoration: underline; cursor: pointer; }
.zac-zips-list          { font-family: monospace; font-size: 11px; line-height: 1.5; word-break: break-all; max-height: 220px; overflow: auto; }
.zac-zip-changed        { color: #d32f2f; font-weight: 700; }
.zac-highlight-btn      { font-size: 10px !important; min-width: 0 !important; padding: 0 6px !important; }
</style>
